import { styled, theme } from "@theme/stitches.config"

export const CardsThreeColumnsWrapper = styled("div", {
    display: "flex",
    width: "100%",
    flexDirection: "column"
})

export const Content = styled("div", {

})

export const CardsWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.colors.effieGold}`,
    borderRadius: 6,
    mt: 40,
    "@lgUp": {
        mt: 60,
        flexDirection: "row"
    }
})

export const Card = styled("div", {
    padding: 30,
    display: "flex",
    flexDirection: "column",
    flex: "1 0 33.33%",
    "&:not(:first-child)": {
        borderTop: `1px solid ${theme.colors.effieGold}`
    },
    "@lgUp": {
        padding: "50px 50px 60px",
        "&:not(:first-child)": {
            borderTop: "none",
            borderLeft: `1px solid ${theme.colors.effieGold}`
        }
    }
})

export const CardIcon = styled("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 9999,
    background: theme.colors.effieBackground,
    width: 60,
    height: 60,
    "& img": {
        maxWidth: 25,
        height: "auto"
    },
    "@lgUp": {
        width: 80,
        height: 80,
        "& img": {
            maxWidth: 32
        }
    }
})

export const Title = styled("p", {
    fontSizePxToRem: 20,
    fontWeight: theme.fontWeights.semiBold,
    mt: 35,
    "@lgUp": {
        fontSizePxToRem: 24,
        mt: 40
    }
})

export const Text = styled("p", {
    fontSizePxToRem: 16,
    fontWeight: theme.fontWeights.medium,
    mt: 10,
    "@lgUp": {
        mt: 20
    }
})

export const StyledLink = styled("a", {
    color: theme.colors.effieGold,
    mt: 20,
    fontWeight: theme.fontWeights.medium,
    "@lgUp": {
        mt: 25,
        fontWeight: theme.fontWeights.semiBold
    }
})
